import SigliveServiceV1 from 'Service/sigliveServiceV1';

const patchSchedule = async ({ id, payload }) => {
  const { data } = await SigliveServiceV1({
    method: 'PATCH',
    url: `/schedule/${id}`,
    data: payload,
  });

  return data;
};

export default patchSchedule;
